var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNextIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.29401 16.7074C9.10654 16.5199 9.00122 16.2656 9.00122 16.0004C9.00122 15.7352 9.10654 15.4809 9.29401 15.2934L12.587 12.0004L9.29401 8.70741C9.11185 8.5188 9.01105 8.2662 9.01333 8.00401C9.01561 7.74181 9.12078 7.491 9.30619 7.30559C9.4916 7.12018 9.74241 7.01501 10.0046 7.01273C10.2668 7.01045 10.5194 7.11125 10.708 7.29341L14.708 11.2934C14.8955 11.4809 15.0008 11.7352 15.0008 12.0004C15.0008 12.2656 14.8955 12.5199 14.708 12.7074L10.708 16.7074C10.5205 16.8949 10.2662 17.0002 10.001 17.0002C9.73584 17.0002 9.48153 16.8949 9.29401 16.7074Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNextIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/next-icon.af62fec442cdb82dd77eb50a21bce02f.svg";